<script setup lang="ts">
import { BasketballEventDetailId } from '@collector/sportsapi-client-legacy'
import RelationView from '@desktop/views/Relation/components/RelationView/RelationView.vue'
import { initSportConfiguration } from '@desktop/views/Relation/Sports/provide-inject'

import BasketballRelation from './components/RelationView/BasketballRelation.vue'
import BasketballStatistics from './components/RelationView/BasketballStatistics.vue'
import {
  addIncidentConfig,
  assignPlayerOnPitchConfig,
  eventDurationConfig,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatusAcronymConfig,
  eventStatuses,
  eventStatusIncidentsOnFieldConfig,
  getEventClockSeconds,
  getEventClockTime,
  getEventStatusPeriodLengthMinutes,
  historyFiltersConfig,
  historyIncidentsConfig,
  incidentsQueuePayloadConfig,
  incidentsResultConfig,
  incidentsTeamPossessionConfig,
  isValidEventClockTime,
  lineupConfig,
  manualAddIncidentConfig,
  pitchBlockedEventStatus,
  pitchIncidentsConfig,
  pitchOverlaySupportedStatuses,
  playersConfig,
  pocketIncidentsConfig,
  resultWithSliderConfig,
  sameTimeIncidentsConfig,
} from './configuration'

initSportConfiguration({
  addIncidentConfig,
  hasChangeSides: true,
  clock: {
    eventDurationConfig,
    getEventClockSeconds,
    getEventClockTime,
    getEventStatusPeriodLengthMinutes,
    isValidEventClockTime,
    maxPeriodLengthMinute: true,
    minutesMaxDigits: 2,
    timerDirectionEventDetailId: BasketballEventDetailId.TimerDirection,
  },
  defaultSkinPatternId: 22,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatusAcronymConfig,
  eventStatuses,
  historyFiltersConfig,
  historyIncidentsConfig,
  incidentsQueuePayloadConfig,
  incidentsResultConfig,
  incidentsTeamPossessionConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitch: {
    assignPlayerOnPitchConfig,
    eventStatusIncidentsOnFieldConfig,
    pitchBlockedEventStatus,
    pitchIncidentsConfig,
    pitchOverlaySupportedStatuses,
  },
  playersConfig,
  pocketIncidentsConfig,
  resultWithSliderConfig,
  sameTimeIncidentsConfig,
  verifyResultSummaryConfig: {
    isDrawPossible: true,
  },
})
</script>

<template>
  <RelationView
    :relation="BasketballRelation"
    :statistics="BasketballStatistics"
  />
</template>
